import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { STATIC_IMAGES } from '@constants';
import { generateSlideImageUrl } from '@utils/generateAssetLinks';

const Pointer = styled.img`
    position: absolute;
    display: ${({showPointer}) => showPointer ? 'block': 'none'};
    width: 40px;
    height: 40px;
    z-index: 13;
`;

export const PointerImage = ({ showPointer, position }) => {
    const pointer = useRef(null);

    useEffect(() => {
        const { x, y } = position;

        if (showPointer) {
            pointer.current.style.left = `${x}px`;
            pointer.current.style.top = `${y}px`;
        }
    }, [position]);

    return (
        <Pointer
            ref={pointer}
            showPointer={showPointer}
            src={generateSlideImageUrl(STATIC_IMAGES.pointer)}
            alt='Red pointer image following the representative`s mouse' />
    );
};

export default PointerImage;
